import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import Frame from '../components/Frame.tsx';
import BalloonPlot from '../components/BalloonPlot';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "balloon-plot"
    }}>{`Balloon Plot`}</h1>
    <p>{`See the component `}<a parentName="p" {...{
        "href": "https://github.com/kristw/encodable/tree/master/packages/docs/src/components/BalloonPlot"
      }}>{`source code`}</a>{`.
or play with the component API by editing the code below.`}</p>

    <Playground __position={0} __code={'<Frame width={360} height={270} background=\"#A8E6FF\">\n  <BalloonPlot\n    width={360}\n    height={270}\n    encoding={{\n      x: { field: \'category\', type: \'nominal\', scale: { type: \'point\' } },\n      y: {\n        field: \'profit\',\n        type: \'quantitative\',\n      },\n      size: {\n        field: \'marketingCost\',\n        type: \'quantitative\',\n        scale: { zero: true, range: [0, 2500] },\n      },\n      color: {\n        field: \'category\',\n        type: \'nominal\',\n        scale: {\n          range: [\'#42B537\', \'#F08900\', \'#E5090B\', \'#9E4DFF\'],\n        },\n      },\n      text: { field: \'category\' },\n      text2: { field: \'profit\', format: \',d\' },\n    }}\n    data={[\n      {\n        category: \'Toys\',\n        marketingCost: 100,\n        profit: 4000,\n      },\n      {\n        category: \'Office supplies\',\n        marketingCost: 200,\n        profit: 3000,\n      },\n      {\n        category: \'Grocery\',\n        marketingCost: 400,\n        profit: 2000,\n      },\n      {\n        category: \'Electronics\',\n        marketingCost: 300,\n        profit: 6000,\n      },\n      {\n        category: \'Clothing\',\n        marketingCost: 400,\n        profit: 1500,\n      },\n    ]}\n  />\n</Frame>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Frame,
      BalloonPlot,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Frame width={360} height={270} background="#A8E6FF" mdxType="Frame">
    <BalloonPlot width={360} height={270} encoding={{
          x: {
            field: "category",
            type: "nominal",
            scale: {
              type: "point"
            }
          },
          y: {
            field: "profit",
            type: "quantitative"
          },
          size: {
            field: "marketingCost",
            type: "quantitative",
            scale: {
              zero: true,
              range: [0, 2500]
            }
          },
          color: {
            field: 'category',
            type: 'nominal',
            scale: {
              range: ['#42B537', '#F08900', '#E5090B', '#9E4DFF']
            }
          },
          text: {
            field: "category"
          },
          text2: {
            field: "profit",
            format: ",d"
          }
        }} data={[{
          category: "Toys",
          marketingCost: 100,
          profit: 4000
        }, {
          category: "Office supplies",
          marketingCost: 200,
          profit: 3000
        }, {
          category: "Grocery",
          marketingCost: 400,
          profit: 2000
        }, {
          category: "Electronics",
          marketingCost: 300,
          profit: 6000
        }, {
          category: "Clothing",
          marketingCost: 400,
          profit: 1500
        }]} mdxType="BalloonPlot" />
  </Frame>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      